module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "dof-colmo-tag weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.currentStyle, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.content))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3b10cf6a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b10cf6a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-colmo-tag/index.vue
// module id = 605
// module chunks = 0 1